export { TCSGileadCommOption } from './generated/TCSGileadCommOption.js';